
import React, { Component } from 'react';
import { Modal, Row, Divider, Button, Table, Descriptions, Tooltip } from 'antd';

const fields = [{
    "text": "申请单号",
    "field": "applicationId",
}, {
    "text": "车架号",
    "field": "vin",
}, {
    "text": "旧车牌号",
    "field": "plateNo",
}, {
    "text": "新车牌号",
    "field": "newPlateNo",
}, {
    "text": "所属商户",
    "field": "memberName",
}, {
    "text": "车型",
    "field": "brandModel",
}, {
    "text": "选牌方式",
    "field": "selectPlateWayStr",
}, {
    "text": "选牌方式备注",
    "field": "selectPlateRemark",
}, {
    "text": "代办费用",
    "field": "commission",
}, {
    "text": "是否需要临时牌",
    "field": "needTempPlate",
    "format": { 0: "否", 1: "是" }
}, {
    "text": "实际费用",
    "field": "actualComission",
}, {
    "text": "状态",
    "field": "statusStr",
}];


class AgentApplyRecord extends Component {
    columns = [{
        title: '操作人员',
        dataIndex: 'operator',
        width: '10%',
    }, {
        title: '操作时间',
        dataIndex: 'operateTime',
        width: '15%',
    }, {
        title: '状态',
        dataIndex: 'operateType',
        width: '10%',
    }, {
        title: '备注信息',
        dataIndex: 'remark',
        width: '30%',
        render: (text, record, index) => (
            <div>
                <Tooltip title={text}>{text}</Tooltip>
            </div>
        ),
    }];

    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="过户流程详情"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions title="" bordered column={2}>
                    {fields.map((item, index) => {
                        let val = editData[item.field];
                        if (item.format != null) {
                            val = item.format[val];
                        }
                        return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>
                    })}
                </Descriptions>
                <Row>
                    <Divider orientation="left">变更记录</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.props.editData.list}
                        pagination={{ pageSize: 10 }}
                        bordered={true}
                    />
                </Row>
            </Modal>
        );
    }
}


export default AgentApplyRecord;